<template>
  <v-container fluid class="px-0 py-0">
    <v-layout row nowrap>
      <v-flex sm5 md4 lg3 class="pr-3">
        <tree :cfg="treeCfg" :timestamp="treeTimestamp" @active="onActive" />
      </v-flex>
      <v-flex sm7 md8 lg9 class>
        <p class="sys-info" v-if="info">{{ info }}</p>
        <template v-if="mediaIds && mediaIds.length > 0">
          <v-btn-toggle v-if="mediaIds.length > 1" v-model="currentMediaIdx" light class="mb-3" @change="onMedia">
            <v-btn v-for="(m, idx) in mediaIds" small flat color="primary" :key="m.id"
              :title="'视频' + (idx + 1) + ': ' + m.name">{{ parseMediaDur(m.dur) }}</v-btn>
          </v-btn-toggle>
          <TencentVideoViewer v-if="type == 8" :cfg="{ 'psign': tecentPsgin, 'fileId': mediaIds[currentMediaIdx] }">
          </TencentVideoViewer>
          <CcVideoViewer v-else :cfg="{ 'movieUrl': movieUrl }"></CcVideoViewer>
          <v-btn @click="onFavorite" v-if="movieUrl" color="primary">
            <v-icon>favorite_border</v-icon>收藏当前视频
          </v-btn>
        </template>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import CcVideoViewer from "@/components/cc-video-viewer.vue";
import TencentVideoViewer from "@/components/tencent-video-viewer.vue";
import { Tree } from "javaee-fre";

export default {
  name: "courseware-view",
  data() {
    return {
      movieUrl: null,
      treeCfg: null,
      treeTimestamp: Date.now(),
      mediaIds: [],
      currentMediaIdx: 0,
      info: null,
      type: 0,//8:腾讯视频,其他:普通视频
      tecentPsgin: null
    };
  },
  components: {
    CcVideoViewer,
    TencentVideoViewer,
    Tree
  },
  props: {
    cfg: Object
  },
  beforeMount() {
    this.init();
  },
  watch: {
    cfg() {
      this.init();
    }
  },
  methods: {
    onFavorite() {
      let self = this;
      if (self.mediaIds && self.currentMediaIdx < self.mediaIds.length) {
        self.$favorite(1, self.mediaIds[self.currentMediaIdx].id);
      }
    },
    parseMediaDur(dur) {
      let m = Math.floor(dur / 60).toFixed(0),
        s = dur % 60;
      return m == 0 ? dur + "''" : m + "'" + (s == 0 ? "" : s + "''");
    },
    init() {
      let self = this,
        cfg = self.cfg;
      if (!cfg.targetId) return;

      //加载一下视频信息，设置一下 type
      self.$axios.get(`/home/my/courseware/get/${cfg.targetId}`).then(r => {
        if (r && r.data && r.data.status == "ok") {
          self.type = r.data.message.tmpId;
        }

        self.treeCfg = {
          label(i) {
            return i ? `${i.label}(${self.parseMediaDur(i.mediaDur)})` : "";
          },
          multiLine: true,
          hasChildren(i) {
            return i.itemCount && i.itemCount > 0;
          },
          url() {
            return `/home/my/courseware/items/list/${cfg.targetId}`;
          }
        };

        self.treeTimestamp = Date.now();
      });
    },
    onActive(i) {
      let self = this;
      self.mediaIds = [];
      self.info = null;
      self.$nextTick(() => {
        if (i) {
          if (i.mediaIds) {
            if (self.type == 8) {
              self.currentMediaIdx = 0;
              self.mediaIds = [i.mediaIds];
              self.onMedia();
              return;
            }
            self.$axios
              .get(`/home/my/courseware/item/medias/${self.cfg.targetId}/${i.id}`)
              .then(r => {
                if (r && r.data && r.data.status == "ok") {
                  self.currentMediaIdx = 0;
                  self.mediaIds = r.data.message || [];
                  if (self.mediaIds.length == 0) { self.info = '该小节对应的视频已找不到～（请确认是否是第三方课件迁移）'; } else {
                    self.onMedia();
                  }
                }
              });
          } else {
            self.info = i.itemCount ? '点击左边章节下级小结可预览视频～' : '该小节没有设置视频～';
          }
        }
        self.currentMediaIdx = 0;
        self.mediaIds = [];
        self.onMedia();
      });
    },
    onMedia() {
      let self = this;
      if (
        self.currentMediaIdx === undefined ||
        self.mediaIds.length == 0 ||
        self.currentMediaIdx >= self.mediaIds.length
      ) {
        return;
      }
      if (self.type == 8) {
        self.$axios
          .get(`/home/my/tencent/vod/play/params/${self.cfg.targetId}/${self.mediaIds[self.currentMediaIdx]}`)
          .then(r => {
            if (r && r.data && r.data.status === "ok") {
              self.tecentPsgin = r.data.message;
            }
          });
        return;
      }
      self.$axios
        .get(`/home/my/media/cc/url/${self.mediaIds[self.currentMediaIdx].id}`)
        .then(r => {
          if (r && r.data && r.data.status === "ok") {
            self.movieUrl = r.data.message;
          }
        });
    }
  }
};
</script>
